<div class="container-fluid">
  <form [formGroup]="noteAddForm">
    <!-- Master -->
    <div class="row wrap">
      <mat-form-field class="col-md-6">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Max size 8 words" readonly="{{formReadOnly}}" maxlength="251">
        @for (validation of validationMessages.title; track validation) {
          <mat-error>
            @if (noteAddForm.get('title').hasError(validation.type) && (noteAddForm.get('title').dirty || noteAddForm.get('title').touched)) {
              <mat-error class="error-message">
              {{validation.message}}</mat-error>
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="col-lg-3 col-md-6">
        <mat-label>Note Type</mat-label>
        <mat-select [(value)]="noteAddForm.value.noteType" formControlName="noteType" (selectionChange)="notesUpdate()" >
          @for ( stat of noteTypes; track  stat) {
            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
          }
        </mat-select>
        @for (validation of validationMessages.noteType; track validation) {
          <mat-error>
            @if (noteAddForm.get('noteType').hasError(validation.type) && (noteAddForm.get('noteType').dirty || noteAddForm.get('noteType').touched)) {
              <mat-error class="error-message">
                {{validation.message}}
              </mat-error>
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="col-lg-3 col-md-6">
        <mat-label>
        Visibility</mat-label>
        <mat-select [(value)]="noteAddForm.value.visibility" formControlName="visibility" (selectionChange)="notesUpdate()">
          @for ( stat of visibilities; track  stat) {
            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
          }
        </mat-select>
        @for (validation of validationMessages.visibility; track validation) {
          <mat-error>
            @if (noteAddForm.get('visibility').hasError(validation.type) && (noteAddForm.get('visibility').dirty || noteAddForm.get('visibility').touched)) {
              <mat-error class="error-message"
                >
              {{validation.message}}</mat-error>
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="col-lg-3 col-md-6">
        <mat-label>
        Status</mat-label>
        <mat-select [(value)]="noteAddForm.value.status" formControlName="status" (selectionChange)="notesUpdate()">
          @for ( stat of statuses; track  stat) {
            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
          }
        </mat-select>
        @for (validation of validationMessages.status; track validation) {
          <mat-error>
            @if (noteAddForm.get('status').hasError(validation.type) && (noteAddForm.get('status').dirty || noteAddForm.get('status').touched)) {
              <mat-error class="error-message">
              {{validation.message}}</mat-error>
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Master -->
    <div class="row">
      <div class="col-lg-12">
        <mat-card>
          <mat-card-content>
            <div><p>Description</p></div>
          <editor formControlName="description" id="description25" [init]="{
							height: 600,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
          </div>
          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!noteId) {
              <button (click)="formAdd()" class="btn-addt p-button">Add</button>
            }
            @if (noteId) {
              <button (click)="formUpdate()" class="btn-upt p-button">Update</button>
            }
          </div>
        </div>
      </div>
    </div>
    <!--
    <br> <span style="float:right;">Sort <p-dropdown [options]="filters" optionLabel="label" (onChange)="sortList($event)"> </p-dropdown></span> <br>
    <br> -->
  </form>
</div>
